"use client";

import { SplitBar, SplitBarItem } from "daskapital-ds";

import { BlocksProps } from "@/lib/wordpress/_types/blocksStyle";
import getBlockStyles from "@/lib/wordpress/blocks/getBlockStyles";
import { mediaIconElement } from "@/lib/wordpress/blocks/mediaIconElement";
import { useMemo } from "react";

export type IBlockSplitBar = {
  attrs: {
    anchor?: string;
    className?: string;
    style?: Record<string, unknown>;
  };
  innerBlocks: BlocksProps[];
};

type ISplitBarItemAttrs = {
  variant?: "light" | "dark";
  background?: string;
  textOverride?: boolean;
  titleColor?: string;
  bodyColor?: string;
  label?: string;
  description?: string;
  mediaUrl?: string;
  mediaAlt?: string;
  mediaSize?: string;
};

export default function BlockSplitBar({ attrs, innerBlocks }: IBlockSplitBar) {
  const { className, style } = attrs || {};

  const elStyle = useMemo(() => ({ ...getBlockStyles({ style }) }), [style]);

  return (
    <SplitBar className={className} style={elStyle}>
      {!!innerBlocks?.length &&
        innerBlocks.map((item: BlocksProps, index: number) => {
          const itemAttrs = (item?.attrs || {}) as ISplitBarItemAttrs;

          return (
            <SplitBarItem
              key={`split-bar-item-${index}`}
              variant={itemAttrs.variant}
              titleColor={itemAttrs.textOverride ? itemAttrs.titleColor : undefined}
              bodyColor={itemAttrs.textOverride ? itemAttrs.bodyColor : undefined}
              className={itemAttrs.background}
              icon={mediaIconElement(itemAttrs)}
              label={itemAttrs.label}
              description={itemAttrs.description?.replace(/\n/g, "<br />")}
            />
          );
        })}
    </SplitBar>
  );
}
